import { Size, CanvasData, ImageData, Text } from "@/types";

export const addImage = (
    context: CanvasRenderingContext2D,
    image: HTMLImageElement,
    size: Size
) => {
    context.canvas.width = size.width;
    context.canvas.height = size.height;
    context.drawImage(image, 0, 0, size.width, size.height);
};

export const getImageData = (canvasData: CanvasData) => {
    if (canvasData.context) {
        return canvasData.context.getImageData(
            0,
            0,
            canvasData.size.width,
            canvasData.size.height
        ).data as unknown as ImageData;
    } else {
        return [] as ImageData;
    }
};

export const updateText = (
    context: CanvasRenderingContext2D,
    text: Text,
    size: Size
) => {
    const margin = 10;
    const lineHeight = 0.8;
    context.fillStyle = "white";
    context.fillRect(0, 0, size.width, size.height);

    const words = text.content.split(" ");
    context.fillStyle = "black";
    context.textBaseline = "top";
    context.font = text.size + "px " + text.font;

    let x = margin;
    let y = margin;
    const spaceWidth = context.measureText(" ").width;
    for (const word of words) {
        const width = context.measureText(word).width;
        if (x !== margin && x + width + margin > size.width) {
            y += text.size * lineHeight;
            x = margin;
        }

        context.fillText(word, x, y);
        x += width + spaceWidth;
    }
};
